import type { FormStepId } from 'shared/config/formStepId';

import type { IOrderedStep, IStepperFormsSet } from '../../types';

interface GetNextActiveStepProps {
  steps: IOrderedStep[];
  forms: IStepperFormsSet;
}

export function getNextActiveStep(props: GetNextActiveStepProps) {
  const { steps, forms } = props;

  return steps.find((step) => {
    const { formId } = step;
    const formData = forms[formId as FormStepId];

    return !formData?.isFullFilled;
  });
}
